import React from "react";
import "./beneficios.css"
import TitleDisplayerComponent from "../TitleDisplayer/titledisplayer";
import { useInView } from "react-intersection-observer";

function Beneficios() {

    const { ref: beneficiosImg, inView: beneficiosImgIsVisible } = useInView({
        "threshold": .9,
        "initialInView":true
    });
    const {ref: beneficiostxt, inView:beneficiosTxtIsVisible} = useInView({
        
            "threshold": .9,
            "initialInView":true
        });

    return (<>

        <div class="ContentBeneficios">

            <TitleDisplayerComponent text="Beneficios Solar Serdán" color={"red"} />
            <div class="ContentWrapBeneficios">
                <div class="wrapTxtImgBeneficios">

                    <img ref={beneficiosImg} className={`ImgSizeBeneficios ${beneficiosImgIsVisible ? "ImgSizeBeneficiosAnimated1" : ""}`} style={{ height: "220px", width: "220px", margin: "0" }} src="./Images/Sector Agrícola (8).png" alt="Image 1"></img>

                    <div className="lblContainer">
                        <span ref={beneficiostxt} className={`imageLabel ${beneficiosTxtIsVisible ? "imageLabelAnimated" : ""}`} >Menor gasto en <br />energía eléctrica</span>
                    </div>
                </div>
                <div class="wrapTxtImgBeneficios">
                    <img ref={beneficiosImg} className={`ImgSizeBeneficios ${beneficiosImgIsVisible ? "ImgSizeBeneficiosAnimated2" : ""}`} src="./Images/Diseño sin título (45).png" alt="Image 2"></img>
                    <div className="lblContainer">
                        <span ref={beneficiostxt} className={`imageLabel ${beneficiosTxtIsVisible ? "imageLabelAnimated" : ""}`} >Estímulos fiscales</span>
                    </div>
                </div>
                <div className="wrapTxtImgBeneficios">
                    <img ref={beneficiosImg} className={`ImgSizeBeneficios ${beneficiosImgIsVisible ? "ImgSizeBeneficiosAnimated3" : ""}`} src="./Images/Sector Agrícola (11).png" alt="Image 3"></img>
                    <div className="lblContainer">
                        <span ref={beneficiostxt} className={`imageLabel ${beneficiosTxtIsVisible ? "imageLabelAnimated" : ""}`} >Contribución al <br/>medio ambiente</span>
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default Beneficios;